import { render, staticRenderFns } from "./BaseStructure.vue?vue&type=template&id=1bd58a94&scoped=true&"
import script from "./BaseStructure.vue?vue&type=script&lang=js&"
export * from "./BaseStructure.vue?vue&type=script&lang=js&"
import style0 from "styles/components/baseStructure.css?vue&type=style&index=0&id=1bd58a94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd58a94",
  null
  
)

export default component.exports